<template>
    <div class="container-fluid">
        <div class="row p-3">
            <div class="designRowOrga w-100">
                <div class="h3Organization w-50">
                    <img src="../../../assets/images/title-icon.png" alt="">
                    <h3>{{competition.name}}</h3>
                </div>
                <div class="right-header-container">
                    
                    <div class="twoInputs">
                        <div class="btnInsideInput w-100">
                            <button ref="buttonSearch" class="search-btn">
                                <img src="../../../assets/images/SearchIcon.png" alt="">
                            </button>
                            <input type="text" id="free_search" class="form-control" v-model="search"
                                placeholder="Search" autocomplete="off"
                                @input="searchTeam" maxlength="50">
                        </div>
                    </div>
                    <div class="fullInputs mb-4">
                        <div class="oneInput w-100">
                            <select id="filter_dates" class="form-select" v-model="sort" @change="getTeamsScored">
                                <option value="false" selected disabled>Sort by Date</option>
                                <option value="asc">Oldest</option>
                                <option value="desc">Latest</option>
                            </select>
                        </div>
                    </div>
                    
                </div>
                <!-- <router-link class="back-route h3" ref="backBtn" to="/results/team">
                    <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                    {{competition.name}}
                </router-link> -->
            </div>
        

            <div class="tabcontent tabcontent-bark-mode">
                <div class="table-container">
                    <TableComponent :thead="thead" :tbody="newObjectEntity" :keys="keys" @sort="SortCompetition" @update="updateCompetition"
                                    model="teamsScoreCompetition" name="teamsScoreCompetition"
                                    updateUrl="/edit-scores"/>

                    <div class="paginationLink">
                        <pagination :data="laravelData" @pagination-change-page="getTeamsScored" :limit="3">
                            <template #prev-nav>
                                <span>Previous</span>
                            </template>
                            <template #next-nav>
                                <span>Next</span>
                            </template>
                        </pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TableComponent from "../../components/TableComponent";
    import LaravelVuePagination from 'laravel-vue-pagination';
    import score from "../../../api-services/score";
    import competition from "../../../api-services/competition";

    export default {
        name: 'pageShowTeams-userscore',
        data() {
            return {
                thead: ['Name', 'Score'],
                keys: ['name', 'score'],
                permissions: [],
                teams: [],
                competition: {
                    name: ''
                },
                filteredArray: [],
                newObjectEntity: [],
                originalTeams: [],
                laravelData: {},
                error: null,
                search: '',
                sort: false,
                state: false,
                isSearch: false,
                status2:false,
                isActive1: false,
                isActive2: false
            }
        },
        components: {
            TableComponent,
            'Pagination': LaravelVuePagination
        },
        async mounted() {
            this.getTeamsScored();
            const compeId = this.$route.params.id;
            const response = await competition.show(compeId);
            this.competition.name = response.data.data.name;
        },
        methods: {
            async getTeamsScored() {
                const competition_id = this.$route.params.id;
                try {
                    const response = await score.teamsOfComeptition(competition_id);
                    // console.log(response.data.data);
                    this.teams = response.data.data;
                    this.formatHandler(response.data.data);
                    this.laravelData = response.data;
                    this.originalTeams = response.data.data;
                } catch (e) {
                    // console.log(e);
                }
            },
            formatHandler(data) {
                let obj = {id:'',name: '', score: 0};
                let totalScore = 0;
                let totalWeight = 0;
                this.newObjectEntity = [];
                let copyScore = [];
                data.forEach((item) => {
                    obj.id = item.id;
                    obj.name = item.name;
                    if(item.isLeader === 'members'){
                        // item.score.filter(scoreItem => scoreItem.id !== item.leader)
                        item.score.forEach((scoreItem) => {
                            if(scoreItem.id !== item.leader){
                                copyScore.push(scoreItem);
                            }
                        })
                    }else{
                        item.score.forEach((scoreItem) => {
                            if(scoreItem.id === item.leader){
                                copyScore.push(scoreItem);
                            }
                        })
                    }

                    console.log(copyScore);
                    for (let i = 0; i < copyScore.length; i++) {
                        if (item.score[i].score === 0 || item.score[i].score === null) {
                            totalScore += 0;
                            totalWeight = item.score[i].totalWeight;
                        } else {
                            totalScore += parseInt( item.score[i].score);
                            totalWeight = item.score[i].totalWeight;
                        }
                    }
                    obj.score = totalScore / copyScore.length;
                    obj.totalWeight = totalWeight;
                    this.newObjectEntity.push(obj);
                    obj = {id:'',name: '', score: 0};
                    totalScore = 0;
                    copyScore = [];

                })
                console.log(this.newObjectEntity);
            },
            async SortCompetition(){
                let status = !this.status2;
                this.originalTeams.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                this.status2 = status;
            },
            async updateCompetition(e){
                let filteredData = this.teams.filter(function (data) {
                    return data.id != e;
                });
                this.teams = filteredData;
            },
            searchTeam(e){
                let searchedValue = e.target.value;
                let searchedData = this.originalTeams.filter((data) => data.name.includes(searchedValue));
                this.teams = searchedData;
            },
            // async searchBackEndHandler(){
            //     await this.getTeamsScored();
            // }
        }
    }
</script>

<style scoped>
    .no-data-header{
        font-size: 18px;
    }
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #DDD !important;
        opacity: 0.5 !important; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #DDD !important;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: #DDD !important;
    }
    .create-btn-text{
        font-size: 17px;
    }
    .tabcontent{
        height:73vh;
        padding-top: 0 !important;
        overflow-y: auto;
    }
    .h3Organization{
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
    }
    .h3Organization img{
        margin-bottom:0;
        padding-right: 10px;
    }
    .h3Organization h3{
        text-transform: uppercase;
        font-weight: 600;
        margin-bottom: 0;
        font-size: calc(1.1rem+0.6vw);
    }
    .right-header-container{
        display: flex;
        flex-direction: row;
        justify-content:end;
        gap:10px;
        width:45%;
        height: 35px;
    }
    .right-header-container .btn-container{
        font-size: 16px;
        width: 25%;
        font-weight: normal;
    }
    .twoInputs{
        width:45%;
    }
    .search-btn{
        width: 10%;
        border-radius: 6px 0 0 6px;
        background-color:#707070;
        align-items: center;
        padding-bottom: 3px;
    }
    .btnInsideInput{
        border-radius: 6px;
        background-color: #707070;
    }
    .btnInsideInput input{
        border-radius: 6px;
        background-color: #707070;
        padding-left: 0;
        padding-top: 5px;
        padding-bottom: 0;
        
    }
    .form-control {
        color: white !important;
        display: flex;
        justify-content: left;
        width:90% !important;
        padding-left: 10px !important;
    }
    .designRowOrga{
        padding-left:40px !important;
        padding-right: 40px;
        height: 50px;
        align-items: center;
        margin-bottom: 2%;
    }
    .paginationLink{
        font-size:11px;
        font-weight: bold;
        width:99%;
    }
    .fullInputs{
        width:25%;
        height: 100%;
    }
    .oneInput{
        height: 100%;
    }
    #filter_dates{
        width:100% !important;
        border: none;
        padding:0;
        padding-left: 10px;
        height: 100% !important;
    }
    #free_search::placeholder{
        opacity: 1 !important;
        color: white !important;
        /* font-size: 19px; */
    }
    @media(max-width:1280px){
        .h3Organization{
            width: 40% !important;
        }
        .h3Organization img{
            width: 5vh !important;
        }
        .right-header-container{
            width:60%;
            /* margin-top: 10px; */
        }
        .twoInputs{
            margin-bottom:0 !important;
        }
        .table-container :deep(thead :first-child){
        width:40% !important;
        }
        .tabcontent{
            padding-top: 0 !important;
            overflow-y: scroll;
        }
    }
    @media(max-height:767px){
        .tabcontent{
            height: 69vh;
        }
    }
</style>